import { useState } from 'react';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Button } from 'reactstrap';
import { motion, AnimatePresence } from "framer-motion";


const DarkNoInternet = ({ style, t, Nouser, imgLoaded }) => {
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [snackbar, setSnackbar] = useState({
        show: false,
        message: '',
        type: 'error'
    });

    // Fallback SVG when image isn't loaded
    const fallbackSVG = (
        <svg width="250" height="250" viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="125" cy="125" r="100" fill="#f0f0f0" />
            <path d="M125 75v100M75 125h100" stroke="#ccc" strokeWidth="8" strokeLinecap="round" />
        </svg>
    );

    const checkInternetConnection = async () => {
        // First check navigator.onLine
        if (!navigator.onLine) {
            return false;
        }

        // Double-check with a real network request
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            clearTimeout(timeoutId);
            return true;
        } catch (error) {
            console.log('Network check failed:', error);
            return false;
        }
    };

    // Refresh page handler
    const handleRefresh = async () => {
        setIsRefreshing(true);

        const isOnline = await checkInternetConnection();
        if (!isOnline) {
            setSnackbar({
                show: true,
                message: t.nointerDes,
                type: 'error'
            });
            setTimeout(() => {
                setSnackbar({ show: false, message: '', type: 'error' });
                setIsRefreshing(false);
            }, 3000);
            return;
        } else {
            window.location.reload();
        }
    };

    return (
        <div style={style}>
            <Row className='d-flex justify-content-center align-items-center page1-bg-90vh m-0'>
                <Col sm={9} xl={5} className='h-100 d-flex flex-column justify-content-evenly align-items-center'>
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <div className='pb-5'>
                            {imgLoaded ? (
                                <img
                                    src={Nouser}
                                    alt='NoDataFound'
                                    className='img-fluid'
                                    width={250}
                                />
                            ) : (
                                fallbackSVG
                            )}
                        </div>
                        <p className='fw-bold fs-5 m-0 text-white'>{t.oops}</p>
                        <p className='fw-bold fs-5 m-0 text-white'>{t.nointer}</p>
                        <p className='m-0 pt-0 text-center' style={{ color: "#AAAAAA", whiteSpace: "pre-line" }}>
                            {t.nointerDes}
                        </p>
                    </div>

                    {/* Refresh Button */}
                    <Button
                        className="mt-4 border-0"
                        onClick={handleRefresh}
                        disabled={isRefreshing}
                        style={{
                            background: isRefreshing ? "#cccccc" : "#FC674A",
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 0,
                            cursor: isRefreshing ? "not-allowed" : "pointer",
                            opacity: isRefreshing ? 0.6 : 1
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowsRotate}
                            className={isRefreshing ? 'fa-spin' : ''}
                        />
                    </Button>

                </Col>
            </Row>

            <AnimatePresence>
                {snackbar.show && (
                    <motion.div
                        className={`snackbar d-flex align-item-center gap-3 ${snackbar.type}`}
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        transition={{
                            duration: 0.3,
                            ease: [0.4, 0, 0.2, 1]
                        }}
                    >
                        <div className="snackbar-icon px-3">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" stroke="#fff" strokeWidth="2" fill="none" />
                                <path d="M10 6V11" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                                <circle cx="10" cy="14" r="1" fill="#fff" />
                            </svg>
                        </div>
                        <div className="snackbar-message">
                            {snackbar.message}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default DarkNoInternet;